import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { setOutOfService } from 'redux/actions';
import SearchBar from 'components/SearchBar';
import AccountMenu from 'components/AccountMenu';
import BurgerMenu from 'components/BurgerMenu';
import StyledBadge from 'components/Badge'
import MessageBox from 'components/MessageBox'
import AlertBox from 'components/AlertBox'
import useAlerts from 'customHook/useAlerts';
import useMessages from 'customHook/useMessages';
import ModalOutOfService from 'screens/ModalOutOfService';
import { HeaderContainer, Messages, Alerts } from './styles';
import Logo from 'assets/Logo.png'
import BellIcon from 'assets/svg/Bell.svg';
import MessageIcon from 'assets/svg/Message.svg';

const Header = ({ subHeader, additionalstyle, desktop, mobile, open, mobileSubHeaderHidden }) => {

  const [ messagesActive, setMessagesActive ] = useState(false);
  const [ alertsActive, setAlertsActive ] = useState(false);
  const { data: alertsData } = useAlerts();
  const { data: messagesData } = useMessages();
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const outOfService = useSelector(state => state.errorReducer.outOfService)

  return (
    <>
      <HeaderContainer additionalstyle={additionalstyle} desktop={desktop} mobile={mobile} open={open}>
        <a
          className='headerTitle'
          href='https://pms.rookhotel.com/' // Fallback URL for native browser behaviors
          rel='noopener noreferrer'
          onClick={(event) => {
            // Handle special key combinations (Ctrl/Cmd+click)
            if (event.metaKey || event.ctrlKey) {
              // Allow default behavior (opens in new tab)
              return;
            }
            
            // Prevent default anchor behavior (full page reload)
            event.preventDefault();
            
            // Perform client-side navigation
            navigate('/floor');
          }}
        >
          <img
            src={Logo}
            alt="Logo"
            width={41}
            height={31}
          />
          <span className='highlight'>ROOK</span>
          <span>HOTEL</span>
        </a>
        <SearchBar
          additionalstyle={`
            position: absolute;
            top: 1px;
            right: 210px;
          `}
        />
        <AccountMenu />
        <Messages
          active={messagesActive}
          onClick={() => {
            if(messagesData?.latestIncomingMessages.items?.length)  {
              setMessagesActive(!messagesActive)
              setAlertsActive(false)
            }
          }}
        >
          <StyledBadge
            className="badge"
            color="error"
            badgeContent=" "
            variant="dot"
            invisible={!messagesData?.latestIncomingMessages.items?.length}
            right={'4px'}
            top={'0px'}
          >
            <img src={MessageIcon} alt={'messageIcon'}/>
          </StyledBadge>   
        </Messages>
        <Alerts
          active={alertsActive}
          onClick={() => {
            if(alertsData?.allRoomAlerts?.length)  {
              setAlertsActive(!alertsActive)
              setMessagesActive(false)
            }
          }}
        >
          <StyledBadge
            className="badge"
            color="error"
            badgeContent=" "
            variant="dot"
            invisible={!alertsData?.allRoomAlerts?.length}
            right={'4px'}
            top={'0px'}
          >
            <img src={BellIcon} alt={'alertIcon'} />
          </StyledBadge>   
        </Alerts> 
        <BurgerMenu />
        <div
          className="outerContainer"
          style={{
            position: 'absolute',
            top: '50px',
            right: 0,
            width: '100vw',
            height: 'calc(100vh - 100px)',
            display: messagesActive ? 'block': alertsActive? 'block':'none'
          }}
          onClick={() => {
            setMessagesActive(false)
            setAlertsActive(false)
          }}
        >
          <MessageBox
            active={messagesActive}
          />
          <AlertBox
            active={alertsActive}
          />
        </div>
      </HeaderContainer>
      <ModalOutOfService
        isOpen={outOfService}
        setClose={() => dispatch(setOutOfService(false))}
      />
    </>
  )
}

export default Header;
